<template>
  <div class="Drawingcontainer" ref="Drawingcontainer">
    <!-- <BarqdisplayGM :barqId="barqId" :viewPortHeight="viewPortHeight" /> -->
    <div class="barqId">
      {{ barqId }}
    </div>
    <vue-drawing-canvas ref="VueCanvasDrawing" :canvasId="ZeichenbrettId" v-model:image="image" :stroke-type="strokeType"
      :fill-shape="fillShape" :eraser="eraser" :lineWidth="line" :color="color" :background-color="backgroundColor"
      :initialImage="initialImage" :lock="true" :width="CanvasWidth" :height="CanvasHeight" :line-cap="lineCap"
      :line-join="lineJoin" style="width: 100%; position: absolute; top: 0px" />
  </div>
</template>

<script>
// import BarqdisplayGM from "./BarqdisplayGM";
import VueDrawingCanvas from "../../services/vue-drawing-canvas";

import reduce from "lodash/reduce";

export default {
  name: "Drawing",
  components: {
    VueDrawingCanvas,
    // BarqdisplayGM,
  },
  props: {
    barqId: {
      type: String,
      default: () => "",
    },
    barqs: {
      type: Object,
      default: () => { },
    },
    lock: {
      type: Boolean,
      default: () => false,
    },
    blankForGM: {
      type: Boolean,
      default: () => false,
    },
    viewPortHeight: {
      type: Number,
      default: () => -1,
    },
  },
  watch: {
    barqId: function (newVal) {
      // watch it
      if (this.barqs[newVal]) {
        if (this.barqs[this.barqId].dimensions) {
          this.CanvasWidth = this.barqs[this.barqId].dimensions.width;
          this.CanvasHeight = this.barqs[this.barqId].dimensions.height;
        }
        console.log(this.barqs[newVal].rawData);
        // this.initialImage = this.barqs[newVal].rawData;
        this.initialImage = this.loadInitialImage(
          this.barqs[this.barqId].rawData
        );
      }
    },
    lock: function (newVal) {
      this.viewOnly = newVal;
    },
  },
  emits: ["msg"],
  data() {
    return {
      ZeichenbrettId: this.barqId.replace("#", ""),
      x: 0,
      y: 0,
      image: "",
      eraser: false,
      disabled: false,
      fillShape: true,
      line: 5,
      color: "#595959",
      strokeType: "dash",
      backgroundColor: "transparent",
      initialImage: [],
      imgsrc: "",
      lineCap: "round",
      lineJoin: "round",
      viewOnly: this.lock,
      farben: [
        "#FF7C21",
        "#5182BB",
        "#0F7F12",
        "#FFFD38",
        "#fa00ff",
        "#595959",
      ],
      CanvasWidth: 1013,
      CanvasHeight: 680,
    };
  },

  methods: {
    loadInitialImage(data) {
      // console.log(data);
      try {
        for (var i = 0; i < data.length; i++) {
          data[i].coordinates = reduce(
            data[i].coordinates,
            (coordinateArray, coordinate) => {
              coordinateArray.push({ x: coordinate[0], y: coordinate[1] });
              return coordinateArray;
            },
            []
          );
        }
      } catch (e) {
        console.log(e);
        this.$emit("msg", "error while loading drawing");
      }
      // console.log(JSON.stringify(data));
      return data;
    },
  },
  created() {
    if (this.barqs[this.barqId]) {
      if (this.barqs[this.barqId].dimensions) {
        this.CanvasWidth = this.barqs[this.barqId].dimensions.width;
        this.CanvasHeight = this.barqs[this.barqId].dimensions.height;
      }
      this.initialImage = this.loadInitialImage(
        this.barqs[this.barqId].rawData
      );
    }
  },
};
</script>

<style scoped>
.barqId {
  font-size: 35px;
  color: var(--barq-orange);
  margin-left: 19%;
}

.viewOnly {
  width: calc(100% - 45px);
  position: absolute;
  height: calc(100% - 4px);
  color: white;
  background: white;
  z-index: 2;
  margin-top: -2px;
}

.Drawingcontainer {
  width: 100%;
  z-index: 1;
  position: relative;
  aspect-ratio: 1013 / 680;
}

.left {
  left: 4px;
}

.right {
  right: 4px;
}

.DecoText {
  font-size: 13px;
  position: absolute;
  top: 2px;
}

.Signature {
  margin-left: 37%;
  line-height: 61px;
}

.ml {
  margin-left: 5px;
}

.mr {
  margin-right: 5px;
}

.Signature>p:after {
  content: "";
  display: block;
  position: absolute;
  top: 14px;
  left: 265px;
  right: 0px;
  bottom: 0px;
  width: 158px;
  height: 33px;
  background-color: white;
  pointer-events: none;
}

#headline {
  height: 65px;
  text-align: center;
  line-height: 65px;
  font-size: 35px;
}

.backgroundImg {
  width: 500px;
  height: 500px;
  position: absolute;
  z-index: -1;
}

.inside {
  display: flex;
  height: 75%;
}

.imgOuter {
  width: 100%;
}

.inside>div>img {
  height: 100%;
  margin: 0 auto;
  display: block;
}

.bottom {
  margin-top: -16px;
  height: 65px;
  position: relative;
}

.Deco {
  height: 100%;
  width: 32px;
  background-color: white;
}

.Outline:before {
  border: 2px solid #fff;
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  border-radius: 70px;
  pointer-events: none;
}

.Outline {
  padding: 0 10px;
  border: 2px solid var(--barq-orange);
  border-radius: 70px;
  position: relative;
  background: var(--barq-orange);
  color: white;
  height: 100%;
}

#farbPalette {
  border: 1px solid black;
}

#master {
  position: relative;
}

vue-drawing-canvas {
  position: absolute;
}

.button-container {
  display: flex;
  position: absolute;
  margin-top: -41px;
  right: -338px;
  background: white;
  padding: 5px 9px;
  border: 3px solid var(--barq-orange);
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom: none;
  padding-right: 97px;
}

.button-container>button,
.button-container>select {
  margin-right: 10px;
  background: hsl(0deg 0% 96%);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid hsl(0deg 0% 40%);
  border-radius: 5px;
  text-align: center;
}

#farbauswahl {
  display: flex;
  flex-wrap: wrap;
}

.farben {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 2px;
  border: 1px solid black;
}

.farben:hover {
  cursor: pointer;
}
</style>
